import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import { I18nProvider } from "./lib/i18n";
import AppShell from "./components/AppShell";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Employees from "./pages/Employees";
import EmployeeDetail from "./pages/EmployeeDetail";
import DocumentsPage from "./pages/DocumentsPage";
import {
  ContractsListPage, PayrollListPage, LeavesListPage, TrainingsListPage,
  PerformanceListPage, AssetsListPage, DisciplineListPage
} from "./pages/ListPages";
import OffboardingPage from "./pages/OffboardingPage";
import Reports from "./pages/Reports";
import AIToolsPage from "./pages/AIToolsPage";

function Guard({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-sm text-muted-foreground font-mono-brand uppercase tracking-wider">
          Loading LogiHR...
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Guard><Dashboard /></Guard>} />
            <Route path="/employees" element={<Guard><Employees /></Guard>} />
            <Route path="/employees/:id" element={<Guard><EmployeeDetail /></Guard>} />
            <Route path="/documents" element={<Guard><DocumentsPage /></Guard>} />
            <Route path="/contracts" element={<Guard><ContractsListPage /></Guard>} />
            <Route path="/payroll" element={<Guard><PayrollListPage /></Guard>} />
            <Route path="/leaves" element={<Guard><LeavesListPage /></Guard>} />
            <Route path="/trainings" element={<Guard><TrainingsListPage /></Guard>} />
            <Route path="/performance" element={<Guard><PerformanceListPage /></Guard>} />
            <Route path="/assets" element={<Guard><AssetsListPage /></Guard>} />
            <Route path="/discipline" element={<Guard><DisciplineListPage /></Guard>} />
            <Route path="/offboarding" element={<Guard><OffboardingPage /></Guard>} />
            <Route path="/reports" element={<Guard><Reports /></Guard>} />
            <Route path="/ai" element={<Guard><AIToolsPage /></Guard>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
